'use client';

import { useEffect, useMemo } from 'react';
import { TrackerExtraInfo, TrackerPosition } from '@diritto/common/tracker/tracking-event.constant';
import { ContentFavoriteAndEpisodeNotiButton } from 'app-components/contents/ContentFavoriteAndEpisodeNotiButton';
import { useContentReactionStore } from 'stores/contents/ContentReactionStore';
import ErrorView from 'ui-components/error/ErrorView';
import { MutableHeaderLayout } from 'ui-components/layout/MutableHeaderLayout';

type ContentDetailPrivatePageProps = {
  contentId: number;
  isApp: boolean;
};

const trackerExtraInfo: TrackerExtraInfo = {
  trackerPosition: TrackerPosition.ContentDetail,
};

export default function ContentDetailPrivatePage({ contentId, isApp }: ContentDetailPrivatePageProps) {
  const { store } = useContentReactionStore();

  useEffect(() => {
    if (!store.state.contents[contentId]) {
      store.updateContentFavoriteCount(contentId, 0);
      store.updateContentNotiCount(contentId, 0);
    }
  }, [contentId, store]);

  const rightButtons = useMemo(
    () => [
      <ContentFavoriteAndEpisodeNotiButton
        key="favoriteAndEpisodeNoti"
        contentId={contentId}
        trackerExtraInfo={trackerExtraInfo}
      />,
    ],
    [contentId],
  );

  return (
    <MutableHeaderLayout isApp={isApp} rightButtons={rightButtons}>
      <ErrorView title="비공개된 작품이에요." description="이 작품은 더 이상 볼 수 없어요." />
    </MutableHeaderLayout>
  );
}
